// extracted by mini-css-extract-plugin
export default {"fallback":"RouteFallback_fallback__ZcrKj","spinner":"RouteFallback_spinner__iL6ki","spin":"RouteFallback_spin__9qfVr"};